import { GET_ALL_PLANT } from './GraphQL/Queries/plantQuery';
import axiosGraphQL from './GraphQL/axiosGraphQL';

export const PlantApi = {
  getAllPlant_Prams: async (params: any) => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_ALL_PLANT,
      variables: {
        skip: 0,
        take: 100,
        input: {
          id: {
            equals: params.plantID,
          },
        },
      },
    });
  },
  getAllPlant: async (id?: string) => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_ALL_PLANT,
      variables: {
        skip: 0,
        take: 100,
        input: {
          id: {
            ...(id && { equals: id }),
            // not: '5000',
          },
        },
      },
    });
  },
  getAllPlantFilterHO: async (id?: string) => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_ALL_PLANT,
      variables: {
        skip: 0,
        take: 100,
        input: {
          id: {
            ...(id && { equals: id }),
          },
        },
      },
    });
  },
  getPlantById: async (id?: any) => {
    return await axiosGraphQL.post('/graphql', {
      query: `query GetAllPlant($input: TplantWhereInput, $skip: Float, $take: Float) {
        getPlant(where: $input, skip: $skip, take: $take,) {
          items {
              id
              name
              companyName
              companyId
              province
              district
          }
        }
      }
      `,
      variables: {
        input: {
          ...((id && { id: { equals: id } }) || {
            id: { not: '5000' },
          }),
        },
      },
    });
  },
  getTypeRevenueComboBox: async (id?: any) => {
    return await axiosGraphQL.post('/graphql', {
      query: `query GetTypeRevenueComBoBox($input:TcodeWhereInput,$skip:Float,$take:Float){
    getCode(where:$input,skip:$skip,take:$take){
        pageInfo{
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
        }
        items{
            id
            name
            value
        }
    }
}
      `,
      variables: {
        input: {
          groupId: { equals: 'DT' },
        },
      },
    });
  },

  getAllPlantComboBox: async () => {
    return await axiosGraphQL.post('/graphql', {
      query: `query GetAllPlant($input: TplantWhereInput, $skip: Float, $take: Float) {
  getPlant(where: $input, skip: $skip, take: $take, orderBy:{createDate: DESC}) {
    pageInfo {
      currentPage
      hasNextPage
      hasPreviousPage
      itemsPerPage
      totalItems
      totalPages
    }
    items {
      id
      name
    }
  }
}
`,
      variables: {
        skip: 0,
        take: 100,
        input: {
          id: {
            not: '5000',
          },
        },
      },
    });
  },
};
